module.exports = __webpack_public_path__ + "img/electric_no_zone_selected.3746e05e.svg";